import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalInsuredInterestName:{
        id:'additional-insured-interest.Name',
        defaultMessage:'Name'
    },
    additionalInsuredType:{
        id:'additional-insured-interest.Type',
        defaultMessage:'Relationship To Primary Named Insured'
    },
    additionalInterestType:{
        id:'additional-insured-interest.Interest Type',
        defaultMessage:'Interest Type'
    },
    additionalType:{
        id:'additional-insured-interest.AdditionalType',
        defaultMessage:'Type'
    },
    additionalInsureds:{
        id:'additional-insured-interest.Additional Insureds',
        defaultMessage:'Additional Insureds'
    },
    additionalInsured:{
        id:'additional-insured-interest.Additional Insured',
        defaultMessage:'Additional Insured'
    },
    additionalNamedInsured:{
        id:'additional-insured-interest.Additional Named Insured',
        defaultMessage:'Additional Named Insured'
    },
    anotherAdditionalInsured:{
        id:'additional-insured-interest.Add Another Additional Insured',
        defaultMessage:'Add Another Additional Insured?'
    },
    anotherAdditionalNamedInsured:{
        id:'additional-insured-interest.Add Another Additional Named Insured',
        defaultMessage:'Add Another Additional Named Insured?'
    },
    additionalInterests:{
        id:'additional-insured-interest.Additional Interests',
        defaultMessage:'Additional Interest'
    },
    additionalInterest:{
        id:'additional-insured-interest.Additional Interest',
        defaultMessage:'Additional Interest'
    },
    anotherAdditionalInterest:{
        id:'additional-insured-interest.Add Another Additional Interest',
        defaultMessage:'Add Another Additional Interest?'
    },
    additionalInterestName:{
        id:'additional-insured-interest.Name',
        defaultMessage:'Name' 
    },
    additionalInterestSave:{
        id:'additional-insured-interest.Name',
        defaultMessage:'Name' 
    },
    additionalInterestCancel:{
        id:'additional-insured-interest.Cancel',
        defaultMessage:'Cancel'
    },
    primaryNumber: {
        id: 'additional-insured-interest.contact-phone-details.Primary number',
        defaultMessage: 'Primary number'
    },
    description: {
        id: 'additional-insured-interest.contact-phone-details.Description',
        defaultMessage: 'Description'
    },
});
